import React, { Suspense } from 'react';

import { Route, RouteProps } from 'react-router-dom';

import { SuspenseRouteFallback } from './SuspenseRouteFallback';

export const SuspenseRoute = ({children, ...rest}: React.PropsWithChildren<Omit<RouteProps, 'children'>>) => {
    return (
        <Route {...rest}>
            <Suspense
                fallback={(
                    <SuspenseRouteFallback/>
                )}
            >
                {children}
            </Suspense>
        </Route>
    );
};
